<template>
  <el-main class="container">
    <div>
    <div class="title">{{title}}</div>
      <div class="box">
        <div class="name">停车券名称</div>
        <el-input
          v-model="body.title"
          clearable
          placeholder="请输入停车券名称"
          type="text"></el-input>
      </div>
      <div class="box">
        <div class="name">停车券券类型</div>
        <el-select
          clearable
          slot="prepend"
          v-model="selectType"
          class="select"
          placeholder="请选择折扣券类型"
          @change="event().selectType($event)">
          <el-option
            v-for="(item,index) in parkCouponType"
            :key="index"
            :value="item">
          </el-option>
        </el-select>
        <div class="discount" v-if="showDiscount">
          折扣<el-input
            v-model="body.discount"
            type="number"
            class="input"><div slot="suffix">折</div></el-input>
        </div>
        <div class="faceValue" v-if="showFaceValue">
          面值抵扣<el-input
            v-model="body.reducePrice"
            type="number"
            class="input"
            clearable></el-input>
        </div>
      </div>
      <div class="box">
        <div class="name">停车券有效期</div>
        <el-date-picker
          v-model="date"
          type="daterange"
          @change="event().selectDate($event)"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </div>
    </div>
    <div class="btn-box">
      <el-button @click="event().goBack()">取消</el-button>
      <el-button type="primary" @click="event().send()">确认</el-button>
    </div>
  </el-main>
</template>

<script>
import { ExchangeDate } from '@/jslib/utils'
import { addParkCoupon, setParkCoupon, getParkCouponDetails } from '@/api/park'
export default {
  data() {
    return {
      parkCouponType: ['折扣券', '面值券'],
      selectType: '',
      body: {
        discount: '',
        endDate: '',
        reducePrice: '',
        startDate: '',
        title: '',
        type: ''
      },
      title: '',
      date: [],
      showDiscount: false,
      showFaceValue: false,
      type: ''
    }
  },
  created() {
    const str = this.$route.path.split('/park-coupon-management/')[1]
    if (str === 'add-park-coupon') {
      this.type = 'add'
      this.title = '新增停车券'
    } else {
      this.type = 'set'
      this.title = '编辑停车券'
    }

    if (str !== 'add-park-coupon') {
      this.network().getParkCouponDetails()
    }
  },
  methods: {
    event() {
      return {
        selectType: (e) => {
          if (e === '折扣券') {
            this.showFaceValue = false
            this.showDiscount = true
            this.body.type = 0
          } else if (e === '面值券') {
            this.showDiscount = false
            this.showFaceValue = true
            this.body.type = 1
          } else {
            this.body.type = ''
            this.showDiscount = false
            this.showFaceValue = false
          }
        },
        selectDate: (e) => {
          if (e == null) {
            this.body.endDate = ''
            this.body.startDate = ''
          } else {
            this.body.startDate = ExchangeDate(this.date[0])
            this.body.endDate = ExchangeDate(this.date[1])
          }
        },
        send: () => {
          if (!this.handlerSend()) return
          if (this.type === 'set') { this.network().setParkCoupon() } else this.network().addParkCoupon()
        },
        goBack: () => {
          this.$router.push('/park-management/park-coupon-management')
        }
      }
    },
    network() {
      return {
        setParkCoupon: async() => {
          await setParkCoupon(this.body)
          this.$message({
            type: 'success',
            message: '修改成功'
          })
          this.$router.push('/park-management/park-coupon-management')
        },
        getParkCouponDetails: async() => {
          const { data } = await getParkCouponDetails(this.$route.params.id)
          Object.assign(this.body, data)
          this.date.push(new Date(this.body.startDate))
          this.date.push(new Date(this.body.endDate))
          if (this.body.type === 0) {
            this.showDiscount = true
            this.selectType = this.parkCouponType[0]
          } else if (this.body.type === 1) {
            this.showFaceValue = true
            this.selectType = this.parkCouponType[1]
          }
        },
        addParkCoupon: async() => {
          await addParkCoupon(this.body)
          this.$message({
            type: 'success',
            message: '添加成功'
          })
          this.$router.push('/park-management/park-coupon-management')
        }
      }
    },
    handlerSend() {
      if (!this.body.title) {
        this.$message({
          type: 'error',
          message: '请输入停车券名称'
        })
        return false
      }
      if (this.body.type === '' || this.body.type === '请选择折扣券类型') {
        this.$message({
          type: 'error',
          message: '请选择停车券类型'
        })
        return false
      }
      if (this.body.type === '0' && !this.body.discount) {
        this.$message({
          type: 'error',
          message: '请输入折扣'
        })
        return false
      }
      if (this.body.type === '1' && !this.body.reducePrice) {
        this.$message({
          type: 'error',
          message: '请输入折扣面值'
        })
        return false
      }
      if (this.body.startDate === '' || this.body.endDate === '') {
        this.$message({
          type: 'error',
          message: '请选择有限时间'
        })
        return false
      }
      return true
    }
  }
}
</script>

<style scoped lang="scss">
.container{
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .title{
    font-weight: bold;
    margin: 15px 0 30px 0;
  }
  .box{
    width: 30%;
    .name{
      margin: 15px 0;
    }
    .discount{
      margin: 30px 0;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .input{
        width: 150px;
        margin-left: 15px;
        /deep/ .el-input__suffix{
          display: flex;
          align-items: center;
        }
      }
    }
    .faceValue{
      margin: 30px 0;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .input{
        width: 150px;
        margin-left: 15px;
      }
    }
  }

  .btn-box{
    display: flex;
    justify-content: center;
  }
}
</style>
